import React from "react";

const DeletedRfqVendorsTable = ({
    suppliers = [],
    formatInvitedOn,
    onReinvite,
    reinviteVendorId,
    canReinvite,
}) => {
    const formatContactValues = (supplier, field) => {
        const values = (supplier?.contactDetails || [])
            .map((contact) => contact?.[field])
            .filter(Boolean);

        return values.length > 0 ? values.join(", ") : "--";
    };

    const formatVendorSource = (source) => {
        const normalizedSource = String(source || "").toUpperCase();

        if (normalizedSource === "MARKETPLACE") return "Marketplace";
        if (normalizedSource === "INTERNAL") return "Internal";
        return "--";
    };
    return (
        <div
            className="mt-3 w-full overflow-auto"
            // style={{ maxHeight: "calc(100vh - 10rem)" }}
        >
            <table className="relative w-full min-w-[1500px]">
                <thead className="text-xs z-10 text-[#727269] dark:bg-gray-700 rounded-lg dark:text-gray-400 sticky top-0 bg-[#F5F5F3]">
                    <tr className="border border-gray-300 rounded-lg max-w-full text-xs">
                        {[
                            "Vendors",
                            "Invited On",
                            "Contact Number",
                            "Email",
                            "Invited By",
                            "Vendor Source",
                            "Deleted On",
                            "Deleted By",
                            "Retain (count)",
                        ].map((header) => (
                            <th
                                key={header}
                                scope="col"
                                className="whitespace-nowrap border-r border-gray-300 px-4 py-2"
                            >
                                <p className="truncate text-left text-xs font-medium text-[#727269]">
                                    {header}
                                </p>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="bg-white">
                    {suppliers.length === 0 ? (
                        <tr className="border-b border-x border-gray-300">
                            <td colSpan={9} className="px-4 py-8 text-center text-sm text-gray-500">
                                No deleted vendors
                            </td>
                        </tr>
                    ) : suppliers.map((supplier) => (
                        <tr
                            key={supplier?.supplierId}
                            className="h-10 border-b border-x border-gray-300 text-xs"
                        >
                            <td className="border-r border-gray-300 px-4 py-2 font-medium">
                                {supplier?.businessName || "--"}
                            </td>
                            <td className="border-r border-gray-300 px-4 py-2 whitespace-nowrap">
                                {formatInvitedOn(supplier?.addedAt)}
                            </td>
                            <td className="border-r border-gray-300 px-4 py-2">
                                {formatContactValues(supplier, "mobile")}
                            </td>
                            <td className="border-r border-gray-300 px-4 py-2">
                                {formatContactValues(supplier, "email")}
                            </td>
                            <td className="border-r border-gray-300 px-4 py-2">
                                {supplier?.addedBy?.name || "--"}
                            </td>
                            <td className="border-r border-gray-300 px-4 py-2">
                                {formatVendorSource(supplier?.vendorSource)}
                            </td>
                            <td className="border-r border-gray-300 px-4 py-2 whitespace-nowrap">
                                {formatInvitedOn(supplier?.deletedAt)}
                            </td>
                            <td className="border-r border-gray-300 px-4 py-2">
                                {supplier?.deletedBy?.name || "--"}
                            </td>
                            <td className="border-r border-gray-300 px-4 py-2">
                                <button
                                    type="button"
                                    onClick={() => onReinvite(supplier?.supplierId)}
                                    disabled={!canReinvite || reinviteVendorId === supplier?.supplierId}
                                    title={!canReinvite ? "Retain is available only for open or draft RFQs" : "Retain vendor"}
                                    className={`whitespace-nowrap border px-3 py-1 text-xs font-medium ${canReinvite
                                        ? "border-green-500 bg-green-100 text-green-800 hover:bg-green-200"
                                        : "cursor-not-allowed border-gray-300 bg-gray-100 text-gray-400"
                                        }`}
                                >
                                    {reinviteVendorId === supplier?.supplierId
                                        ? "Retaining..."
                                        : `Retain (${supplier?.resendCount ?? 0})`}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default DeletedRfqVendorsTable;
